import type { PresetHOC } from '../types/PresetHOC';

/**
 * Add a static property to the Item to inform that the progress bar should be displayed
 * @param {PresetItem} Item The dashboard item to enhance
 */
export const withProgressBar: PresetHOC<{
    showProgressBar?: boolean;
}> = (Item) => {
    Item.showProgressBar = true;

    return Item;
};
